import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  updateActivePageStepNumber,
  updatePageStepToFinish,
  updateStepperIndex
} from "../../../../actions/globalActions";
import {
  FlowSteps,
  ExchangeStep,
  StepBand,
  ActiveIcon,
  StepNumber
} from "./styles";
import { recordError } from "../../../../utils/commonUtil";


import InfoRectangleNPA from "./components/InfoRectangleNPA";

export function Stepper(props) {
  const {
    stepConfig,
    activeStepNumber,
    activeStepName,
    setActivePageStepNumber,
    finishActivePageStep
  } = props;

  const [filled, setFilled] = useState([
    { id: 1, hovered: false },
    { id: 2, hovered: false }
  ]);
  const [isHover, setIsHover] = useState(false);
  const [currentTabHover, setCurrentTabHover] = useState("");

  const renderInfoRectangleNPA = (config, configKey) => {
    if (
      !props.stepperUpdateIndex.status &&
      config.status === "finish" &&
      config.pageName == currentTabHover &&
      (activeStepNumber == 3 || activeStepNumber == 2)
    ) {
      return (
        <InfoRectangleNPA
          data={config}
          closed={e => handleStepMouseLeave(e, configKey, config)}
        />
      );
    }
  };

  function generateTitleNode(config) {
    if (props.stepperUpdateIndex.status === true) {
      if (config && config.key == activeStepNumber) config.status = "process";
    }

    return (
      <>
        <StepBand active={config && config.key <= activeStepNumber} />
        <ActiveIcon
          active={config && config.key === activeStepNumber}
          type="caret-right"
        />
        {renderInfoRectangleNPA(config, config.key)}

        <StepNumber
          activeStep={activeStepNumber}
          allKey={config.key}
          active={config && config.key <= activeStepNumber}
        >{`Step ${config.key}`}</StepNumber>
      </>
    );
  }

  function generateDescriptionNode(description) {
    return (
      <>
        <span>{description}</span>
      </>
    );
  }

  const handleStepMouseEnter = (e, configKey, config) => {
    try {
      let filledArray = [...filled];
      for (let i = 0; i < filledArray.length; i++) {
        if (filledArray[i].id === configKey) {
          filledArray[i].hovered = true;
        } else {
          filledArray[i].hovered = false;
        }
      }
      setFilled(filledArray);
  
      // For NPA
      setIsHover(!isHover);
      setCurrentTabHover(config.pageName);
    } catch (error) {
      recordError(error);
    }
  };

  const handleStepMouseLeave = (e, configKey, config = '') => {
    let filledArray = [...filled];
    for (let i = 0; i < filledArray.length; i++) {
      filledArray[i].hovered = false;
    }
    setFilled(filledArray);
    e.stopPropagation();

    // For NPA
    setIsHover(!isHover);
    setCurrentTabHover("");
  };

  function generateContent(config) {
    return (
      <ExchangeStep
       data-test="exchange-step"
        onMouseEnter={e => handleStepMouseEnter(e, config.key, config)}
        onMouseLeave={e => handleStepMouseLeave(e, config.key, config)}
        key={config.key}
        active={config && config.key === activeStepNumber}
        title={generateTitleNode(config)}
        description={generateDescriptionNode(config.description)}
        status={config.status}
      />
    );
  }

  function generateContentMobile(config) {
    return (
      <ExchangeStep
      data-test="exchange-step-mobile"
        onClick={e => handleStepMouseEnter(e, config.key, config)}
        key={config.key}
        active={config && parseInt(config.key) === parseInt(activeStepNumber)}
        title={generateTitleNode(config)}
        description={generateDescriptionNode(config.description)}
        status={config.status}
      />
    );
  }
  if (!stepConfig.length) return <div>loadingConfig</div>;
  else if (window.screen.width > 991.92) {
    return (
      <FlowSteps current={activeStepNumber}>
        {stepConfig.map(config =>
          generateContent(config)
        )}
      </FlowSteps>
    );
  } else {
    return (
      <FlowSteps  current={activeStepNumber}>
        {stepConfig.map(config =>
          generateContentMobile(config)
        )}
      </FlowSteps>
    );
  }
}

const mapStateToProps = state => ({
  activeStepNumber: state.getIn(["globalState", "activePageStepNumber"]),
  stepConfig: state.getIn(["globalState", "stepperConfig"]),
  stepperUpdateIndex: state.getIn(["globalState", "stepperUpdateIndex"]),
  activeStepName: state.getIn(["recommendAnExchange", "typeActive"])
});

export const mapDispatchToProps = dispatch => ({
  setActivePageStepNumber: stepNumber =>
    dispatch(updateActivePageStepNumber(stepNumber)),
  finishActivePageStep: () => dispatch(updatePageStepToFinish()),
  updateStepperIndex: data => dispatch(updateStepperIndex())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Stepper)
);
